module.exports = __webpack_public_path__ + "img/sjk.b8c86c5e.png";